import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import GoodStroage from './goods-storage/goods-storage'
import PurchaseManage from './purchase-manage/purchase-manage'
import StockManage from './stock-manage/stock-manage'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/goodStorage'} component={GoodStroage}></Route>
            <Route path={props.match.path + '/purchaseManage'} component={PurchaseManage}></Route>
            <Route path={props.match.path + '/stockManage'} component={StockManage}></Route>
        </Switch>
    )
}
